// extracted by mini-css-extract-plugin
export default {"container":"lib-component-mappings-sky-parallax-components-ResponsiveHeroImage__container--nz1vV"};